import { Injectable } from '@angular/core';
import { IOrchestrationTargetingRuleDto } from 'src/app/models/orchestrations';
import { OrchestrationService } from './orchestration.service';

@Injectable({
  providedIn: 'root'
})
export class OrchestrationOrchestrationTargetingRuleService {

    allOrchestrationTargetingRule: IOrchestrationTargetingRuleDto[] = [];

    constructor(private service: OrchestrationService) { }

    async getAllOrchestrationTargetingRules(): Promise<IOrchestrationTargetingRuleDto[]>
    {
        this.allOrchestrationTargetingRule = await this.service.getOrchestrationTargetingRules();
        return this.allOrchestrationTargetingRule;
    }

    async getAllOrchestrationTargetingRuleByOrchestration(Id: number): Promise<IOrchestrationTargetingRuleDto[]> {

        let tenantsRule: IOrchestrationTargetingRuleDto[] = [];

        if( this.allOrchestrationTargetingRule == null || this.allOrchestrationTargetingRule.length == 0)
        {
            await this.getAllOrchestrationTargetingRules();
        }

        this.allOrchestrationTargetingRule.forEach(item=> {
            if(item.orchestrationId == Id)
            {
                tenantsRule.push(item);
            }
        });

        return tenantsRule;
    }

    async saveOrchestrationTargetingRuleItem(orchestrationTargetingRule: IOrchestrationTargetingRuleDto) : Promise<IOrchestrationTargetingRuleDto> {

        if(orchestrationTargetingRule.id == 0)
        {
            orchestrationTargetingRule = await this.createOrchestrationTargetingRuleItem(orchestrationTargetingRule);
            await this.getAllOrchestrationTargetingRules();
        }
        else
        {
            await this.service.saveOrchestrationTargetingRuleChange(orchestrationTargetingRule);
        }

        return orchestrationTargetingRule;
    }

    async createOrchestrationTargetingRuleItem(orchestrationTargetingRule: IOrchestrationTargetingRuleDto) : Promise<IOrchestrationTargetingRuleDto> {

        if(orchestrationTargetingRule.id == 0)
        {
            orchestrationTargetingRule = await this.service.saveCreateOrchestrationTargetingRuleChange(orchestrationTargetingRule);
        }
        return orchestrationTargetingRule;
    }

    getNewOrchestrationTargetingRuleItem(): IOrchestrationTargetingRuleDto {

        return {
            id: 0,
            orchestrationId: 0,
            targetingRuleId: 0,
            tenant: null,
            active: false,
            value: 0,
            metadata: null
        }
    }
}
